import React, { memo } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['Strutturi lezioni di musica più chiare, professionali e coinvolgenti.', 'Mantieni alta la motivazione degli studenti più facilmente.', 'Aiuti i tuoi allievi a progredire in modo più visibile e costante.', 'Risparmi tempo nella preparazione delle lezioni.', 'Ti senti finalmente un insegnante più sicuro, organizzato e valorizzato.'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-235">
      <div className="max-w-5xl mx-auto" data-id="element-236">
        <div className="text-center mb-12" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-4" data-id="element-238">
            Ed è proprio per questo che abbiamo creato il MegaPack Maestro
            Musicale 360°
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-239">
            Un sistema pratico, completo e immediatamente applicabile per
            aiutarti a insegnare musica con più metodo, più sicurezza e più
            risultati.
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-3xl border border-blue-100 p-8 md:p-12 shadow-lg" data-id="element-240">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-241">
            {benefits.map((benefit, index) => <div key={index} className={`bg-white rounded-xl p-6 flex items-start shadow-sm border border-gray-100 ${index === benefits.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-242">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-1 mr-4" data-id="element-243" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-244">{benefit}</p>
              </div>)}
          </div>
        </div>

        <p className="text-center text-xl text-gray-600 italic mt-12 font-medium" data-id="element-245">
          Non si tratta solo di insegnare meglio. Si tratta di far vivere la
          musica in modo più profondo, motivante e memorabile.
        </p>
      </div>
    </section>;
}